import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import { INotification } from '../../commons/interfaces/notification.interface';
import { displayDate } from '../../commons/utils/date.util';
import './style.scss';

interface NotificationItemProps {
  notification: INotification;
  onClick: (notification: INotification) => void;
}

const NotificationItem = ({ notification, onClick }: NotificationItemProps) => {
  const cardClassname = classNames('notification-item cursor-pointer', {
    unseen: !notification.seen
  });

  const handleClick = () => {
    onClick(notification);
  };

  return (
    <Card className={cardClassname} onClick={handleClick}>
      <Card.Body>
        <Card.Subtitle>Nuevo ticket</Card.Subtitle>
        <Card.Text className="mb-0">
          Se ha creado un nuevo ticket: {notification.ticket.code}
        </Card.Text>
        <span className="float-right">
          <small className="text-muted">{displayDate(notification.creationDate, 'lll')}</small>
        </span>
      </Card.Body>
    </Card>
  );
};

export default NotificationItem;
